var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDealsLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0572 17.048H31.2072V16.898V2.93878C31.2072 1.78751 30.2885 0.85 29.15 0.85H2.90718C1.76872 0.85 0.85 1.78752 0.85 2.93879V37.0614C0.85 38.2127 1.76872 39.1502 2.90718 39.1502H30.6758H30.8258V39.0002V38.2247V38.0747H30.6758H2.90718C2.36036 38.0747 1.91287 37.6233 1.91287 37.0614V2.93879C1.91287 2.37684 2.36036 1.92551 2.90718 1.92551H29.15C29.6969 1.92551 30.1443 2.37684 30.1443 2.93878V16.898V17.048H30.2943H31.0572Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.281 10.8435H26.431V10.6935V9.91797V9.76797H26.281H11.6338H11.4838V9.91797V10.6935V10.8435H11.6338H26.281Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.281 17.0476H26.431V16.8976V16.1221V15.9721H26.281H11.6338H11.4838V16.1221V16.8976V17.0476H11.6338H26.281Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.281 23.2517H26.431V23.1017V22.3262V22.1762H26.281H11.6338H11.4838V22.3262V23.1017V23.2517H11.6338H26.281Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70592 10.8435H8.85592V10.6935V9.91797V9.76797H8.70592H4.31177H4.16177V9.91797V10.6935V10.8435H4.31177H8.70592Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70592 17.0476H8.85592V16.8976V16.1221V15.9721H8.70592H4.31177H4.16177V16.1221V16.8976V17.0476H4.31177H8.70592Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70592 23.2517H8.85592V23.1017V22.3262V22.1762H8.70592H4.31177H4.16177V22.3262V23.1017V23.2517H4.31177H8.70592Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4221 29.4568H20.5721V29.3068V28.5312V28.3812H20.4221H11.6338H11.4838V28.5312V29.3068V29.4568H11.6338H20.4221Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1029 17.0064L38.2059 16.8973L38.1029 16.7883L37.5746 16.2288L37.4716 16.1198L37.3687 16.2288L25.6509 28.637L25.5479 28.7461L25.6509 28.8552L26.1792 29.4146L26.2822 29.5237L26.3852 29.4146L38.1029 17.0064Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7592 31.5827L22.6562 31.6918L22.7592 31.8008L23.2875 32.3603L23.3905 32.4693L23.4935 32.3603L24.9582 30.8093L25.0612 30.7002L24.9582 30.5911L24.4299 30.0317L24.3269 29.9226L24.2239 30.0317L22.7592 31.5827Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealsLarge);
export default __webpack_public_path__ + "static/media/deals-large.441dace0.svg";
export { ForwardRef as ReactComponent };